import { RouterProvider } from "react-router-dom";
import { router } from "./lib/router.js";

export function App() {
  return <RouterProvider router={router} />;
}
